// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"dd9b5c59","675":"f0c92331"}[chunkId] + ".chunk.js";
};